
import { defineComponent } from "vue";
import { uuid } from "vue-uuid";
import { FoodItem } from "@/types/Donor";
import { Transaction } from "@/types/Shared";
import TransactionItem from "@/components/Shared/TransactionsView/TransactionItem.vue";

export default defineComponent({
  name: "TransactionsView",
  components: {
    TransactionItem,
  },
  data() {
    return {
      role: "Charity",
      windowWidth: window.innerWidth,
      transactions: [] as Transaction[],
      filteredTransactions: [] as Transaction[],
      activeTab: "Completed",
    };
  },
  methods: {
    onResize() {
      this.windowWidth = window.innerWidth;
    },
    filterTransactions() {
      this.filteredTransactions = Object.assign(
        [],
        this.transactions.filter((transaction) => {
          if (this.activeTab === "Awaiting") {
            return (
              transaction.status === "Pending" ||
              transaction.status === "Awaiting"
            );
          } else {
            return transaction.status === this.activeTab;
          }
        })
      );
    },
    switchTab(tab: string) {
      this.activeTab = tab;
      this.filterTransactions();
    },
  },
  mounted() {
    window.addEventListener("resize", this.onResize);
    this.activeTab = this.setActiveTab;
    this.transactions = [
      {
        transactionId: uuid.v1(),
        donorName: "DonorName 1",
        donorAvatar: "default_profile.png",
        charityName: "Hippodromo Barangay Hall",
        charityAvatar: "default_profile.png",
        distance: 1200,
        deliveryMode: "Pick-up",
        status: "Pending",
        deliveryNotes: "Please deliver the goods to the barangay hall.",
        optionalNotes: "Please deliver the goods to the barangay hall.",
        donations: [
          {
            itemId: uuid.v1(),
            name: "Chicken Breast",
            type: "Meat and Poultry",
            stage: "In Storage",
            quantity: 2,
            weight: 1,
            createdAt: new Date().toString(),
          },
          {
            itemId: uuid.v1(),
            name: "Brussels Sprouts",
            type: "Fruits and Vegetables",
            stage: "Prepared",
            quantity: 1,
            weight: 3,
            createdAt: new Date().toString(),
          },
          {
            itemId: uuid.v1(),
            name: "Tuna Panga",
            type: "Fish and Seafood",
            stage: "In Storage",
            quantity: 2,
            weight: 0.25,
            createdAt: new Date().toString(),
          },
          {
            itemId: uuid.v1(),
            name: "Duck Eggs",
            type: "Eggs and Dairy",
            stage: "Prepared",
            quantity: 2,
            weight: 0.2,
            createdAt: new Date().toString(),
          },
        ] as FoodItem[],
        createdAt: new Date().toString(),
        updatedAt: new Date().toString(),
      },
      {
        transactionId: uuid.v1(),
        donorName: "DonorName 2",
        donorAvatar:
          "https://bestprofilepictures.com/wp-content/uploads/2021/08/Amazing-Profile-Picture-for-Facebook.jpg",
        charityName: "JPIC-IDC Inc.",
        charityAvatar:
          "https://bestprofilepictures.com/wp-content/uploads/2021/08/Amazing-Profile-Picture-for-Facebook.jpg",
        distance: 1500,
        deliveryMode: "Pick-up",
        status: "Cancelled",
        deliveryNotes: "Please deliver the goods",
        optionalNotes: "Please deliver the goods",
        donations: [
          {
            itemId: uuid.v1(),
            name: "Chicken Breast",
            type: "Meat and Poultry",
            stage: "In Storage",
            quantity: 2,
            weight: 1,
            createdAt: new Date().toString(),
          },
          {
            itemId: uuid.v1(),
            name: "Brussels Sprouts",
            type: "Fruits and Vegetables",
            stage: "Prepared",
            quantity: 1,
            weight: 3,
            createdAt: new Date().toString(),
          },
          {
            itemId: uuid.v1(),
            name: "Tuna Panga",
            type: "Fish and Seafood",
            stage: "In Storage",
            quantity: 2,
            weight: 0.25,
            createdAt: new Date().toString(),
          },
          {
            itemId: uuid.v1(),
            name: "Duck Eggs",
            type: "Eggs and Dairy",
            stage: "Prepared",
            quantity: 2,
            weight: 0.2,
            createdAt: new Date().toString(),
          },
        ] as FoodItem[],
        createdAt: new Date().toString(),
        updatedAt: new Date().toString(),
      },
      {
        transactionId: uuid.v1(),
        donorName: "DonorName 3",
        donorAvatar:
          "https://images.unsplash.com/photo-1518806118471-f28b20a1d79d?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&w=1000&q=80",
        charityName: "Cebu Food Bank",
        charityAvatar:
          "https://images.unsplash.com/photo-1518806118471-f28b20a1d79d?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&w=1000&q=80",
        distance: 2500,
        deliveryMode: "Pick-up",
        status: "Completed",
        deliveryNotes: "Please deliver the goods to the Food bank",
        optionalNotes: "Please deliver the goods to the Food bank",
        donations: [
          {
            itemId: uuid.v1(),
            name: "Chicken Breast",
            type: "Meat and Poultry",
            stage: "In Storage",
            quantity: 2,
            weight: 1,
            createdAt: new Date().toString(),
          },
          {
            itemId: uuid.v1(),
            name: "Brussels Sprouts",
            type: "Fruits and Vegetables",
            stage: "Prepared",
            quantity: 1,
            weight: 3,
            createdAt: new Date().toString(),
          },
          {
            itemId: uuid.v1(),
            name: "Tuna Panga",
            type: "Fish and Seafood",
            stage: "In Storage",
            quantity: 2,
            weight: 0.25,
            createdAt: new Date().toString(),
          },
          {
            itemId: uuid.v1(),
            name: "Duck Eggs",
            type: "Eggs and Dairy",
            stage: "Prepared",
            quantity: 2,
            weight: 0.2,
            createdAt: new Date().toString(),
          },
        ] as FoodItem[],
        createdAt: new Date().toString(),
        updatedAt: new Date().toString(),
      },
    ];
    this.filterTransactions();
  },
  computed: {
    setActiveTab: function (): string {
      return this.role === "Charity" ? "Awaiting" : "Completed";
    },
  },
});
